// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_SUBSCRIPTIONS = 'subscription/fetchSubscriptions';
export const {
  pending: FETCH_SUBSCRIPTIONS_PENDING,
  fulfilled: FETCH_SUBSCRIPTIONS_FULFILLED,
  rejected: FETCH_SUBSCRIPTIONS_REJECTED,
} = createAsyncActionTypes(FETCH_SUBSCRIPTIONS);

export const FETCH_SUBSCRIPTION = 'subscription/fetchSubscription';
export const {
  pending: FETCH_SUBSCRIPTION_PENDING,
  fulfilled: FETCH_SUBSCRIPTION_FULFILLED,
  rejected: FETCH_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(FETCH_SUBSCRIPTION);

export const CLOSE_SUBSCRIPTION = 'subscription/closeSubscription';
export const {
  pending: CLOSE_SUBSCRIPTION_PENDING,
  fulfilled: CLOSE_SUBSCRIPTION_FULFILLED,
  rejected: CLOSE_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(CLOSE_SUBSCRIPTION);

export const REACTIVATE_SUBSCRIPTION = 'subscription/reactivateSubscription';
export const {
  pending: REACTIVATE_SUBSCRIPTION_PENDING,
  fulfilled: REACTIVATE_SUBSCRIPTION_FULFILLED,
  rejected: REACTIVATE_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(REACTIVATE_SUBSCRIPTION);

export const CHANGE_SUBSCRIPTION = 'subscription/changeSubscription';
export const {
  pending: CHANGE_SUBSCRIPTION_PENDING,
  fulfilled: CHANGE_SUBSCRIPTION_FULFILLED,
  rejected: CHANGE_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(CHANGE_SUBSCRIPTION);

export const FETCH_PRODUCTS = 'subscription/fetchProducts';
export const {
  pending: FETCH_PRODUCTS_PENDING,
  fulfilled: FETCH_PRODUCTS_FULFILLED,
  rejected: FETCH_PRODUCTS_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCTS);

export const FETCH_CHANNELS = 'subscription/fetchChannels';
export const {
  pending: FETCH_CHANNELS_PENDING,
  fulfilled: FETCH_CHANNELS_FULFILLED,
  rejected: FETCH_CHANNELS_REJECTED,
} = createAsyncActionTypes(FETCH_CHANNELS);

export const RESET_CREDIT_CARD = 'subscription/resetCreditCard';
export const {
  pending: RESET_CREDIT_CARD_PENDING,
  fulfilled: RESET_CREDIT_CARD_FULFILLED,
  rejected: RESET_CREDIT_CARD_REJECTED,
} = createAsyncActionTypes(RESET_CREDIT_CARD);

export const DELETE_PAYMENT_BLOCK = 'subscription/deletePaymentBlock';
export const {
  pending: DELETE_PAYMENT_BLOCK_PENDING,
  fulfilled: DELETE_PAYMENT_BLOCK_FULFILLED,
  rejected: DELETE_PAYMENT_BLOCK_REJECTED,
} = createAsyncActionTypes(DELETE_PAYMENT_BLOCK);

export const DELETE_USER_BLOCK = 'subscription/deleteUserBlock';
export const {
  pending: DELETE_USER_BLOCK_PENDING,
  fulfilled: DELETE_USER_BLOCK_FULFILLED,
  rejected: DELETE_USER_BLOCK_REJECTED,
} = createAsyncActionTypes(DELETE_USER_BLOCK);

export const CREATE_SUPPORT_PRODUCT = 'subscription/createSupportProduct';
export const {
  pending: CREATE_SUPPORT_PRODUCT_PENDING,
  fulfilled: CREATE_SUPPORT_PRODUCT_FULFILLED,
  rejected: CREATE_SUPPORT_PRODUCT_REJECTED,
} = createAsyncActionTypes(CREATE_SUPPORT_PRODUCT);

export const DESELECT_SUBSCRIPTION = 'subscription/deselectSubscription';

export const INVALIDATE_CACHE = 'subscription/invalidateCache';
export const {
  pending: INVALIDATE_CACHE_PENDING,
  fulfilled: INVALIDATE_CACHE_FULFILLED,
  rejected: INVALIDATE_CACHE_REJECTED,
} = createAsyncActionTypes(INVALIDATE_CACHE);

export const CREATE_PARTNER_SUBSCRIPTION = 'partner/createPartnerSubscription';
export const {
  pending: CREATE_PARTNER_SUBSCRIPTION_PENDING,
  fulfilled: CREATE_PARTNER_SUBSCRIPTION_FULFILLED,
  rejected: CREATE_PARTNER_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(CREATE_PARTNER_SUBSCRIPTION);

export const CLOSE_PARTNER_SUBSCRIPTION = 'partner/closePartnerSubscription';
export const {
  pending: CLOSE_PARTNER_SUBSCRIPTION_PENDING,
  fulfilled: CLOSE_PARTNER_SUBSCRIPTION_FULFILLED,
  rejected: CLOSE_PARTNER_SUBSCRIPTION_REJECTED,
} = createAsyncActionTypes(CLOSE_PARTNER_SUBSCRIPTION);

export const ADD_SUBSCRIPTION_DISCOUNT = 'subscription/addSubscriptionDiscount';
export const {
  pending: ADD_SUBSCRIPTION_DISCOUNT_PENDING,
  fulfilled: ADD_SUBSCRIPTION_DISCOUNT_FULFILLED,
  rejected: ADD_SUBSCRIPTION_DISCOUNT_REJECTED,
} = createAsyncActionTypes(ADD_SUBSCRIPTION_DISCOUNT);

export const FETCH_DISCOUNT_REASONS = 'subscription/fetchDiscountReasons';
export const {
  pending: FETCH_DISCOUNT_REASONS_PENDING,
  fulfilled: FETCH_DISCOUNT_REASONS_FULFILLED,
  rejected: FETCH_DISCOUNT_REASONS_REJECTED,
} = createAsyncActionTypes(FETCH_DISCOUNT_REASONS);
